<template>
  <div>
    <div class="footer">
      指导单位：&nbsp;云南省住房和城乡建设厅科技与标准定额处
      <div class="space"></div>
      主办单位：&nbsp;云南省工程建设技术经济室
      <div class="space"></div>
      联系电话：&nbsp;0871-64320642
      <div class="space"></div>
      备案号：&nbsp;<a
        href="https://beian.miit.gov.cn/state/outPortal/loginPortal.action#/Integrated/index"
        target="_blank"
        style="text-decoration: none; color: #666"
        >滇ICP备18001273号</a
      ><br />
      技术支持：&nbsp;昆明行列科技有限公司
      <div class="space"></div>
      技术联系电话：0871-68184040
    </div>
  </div>
</template>

<script>
export default {
  name: "Foot",
};
</script>

<style lang="less" scoped>
.footer {
  font-size: 14px;
  font-weight: 400;
  text-align: center;
  color: #666666;
  line-height: 30px;
  margin-top: 40px;
  .space {
    display: inline-block;
    width: 10px;
  }
}
</style>
